import Integrations from './IntegrationsContainer';
export default Integrations;
